import React, { PropsWithChildren } from 'react';
import theme from './Cards.module.scss';
import { CardSection } from '.';
import { classnames } from '@/utils/html';
import { DropdownContextMenu } from '@ygtechnologies/rubus-ui';

type CardDropdownMenuProps = PropsWithChildren & {
    hidden?: boolean;
    disableMobile?: boolean;
    className?: string;
};

const CardDropdownMenu: React.FC<CardDropdownMenuProps> = ({ children, hidden, className, disableMobile = false }) => {
    return (
        <CardSection
            width="40px"
            className={classnames(theme.cardMenu, className, {
                [theme.hidden]: hidden,
                [theme.disableMobile]: disableMobile,
            })}>
            <DropdownContextMenu hidden={hidden}>{children}</DropdownContextMenu>
        </CardSection>
    );
};

export default CardDropdownMenu;
